/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForIbmTencent extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForIbmTencent");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForIbmTencent.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForIbmTencent>): ServiceAccountNativeDetailsForIbmTencent {
        let obj = Object.assign(new ServiceAccountNativeDetailsForIbmTencent(), model);
        ServiceAccountNativeDetailsForIbmTencent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForIbmTencent>): ServiceAccountNativeDetailsForIbmTencent {
        if (!model) return null;
        return ServiceAccountNativeDetailsForIbmTencent.newInstance(<ServiceAccountNativeDetailsForIbmTencent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForIbmTencent) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForIbmTencent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForIbmTencent): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForIbmTencent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
